import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
@Injectable()
export class AppHttpClient {
  helper: JwtHelperService;
  projectName: string=environment.projectName;
  constructor(private _http: HttpClient, private router: Router) {
    this.helper = new JwtHelperService();
  }

  createHeaders() {
    // 
    if (this.helper.isTokenExpired(localStorage.getItem(this.projectName+"token"))) {
      this.router.navigate(["/auth/login"]);
    } 

    let token = localStorage.getItem(this.projectName+"token");

    if (token != null && token != undefined) {
      return new HttpHeaders().set("x-auth-token", `${token}`);
    } 


    return new HttpHeaders();
  }
  
  get(url: any) {
    return this._http.get(url, {
      headers: this.createHeaders(),
      observe: "response",
    });
  }
  getImage(imageUrl: string) {
    return this._http.get(imageUrl, {
      responseType: "blob",
      headers: this.createHeaders(),
      observe: "response",
    });
  }
  getFile(imageUrl: string) {
    return this._http.get(imageUrl, {
      responseType: "blob",
      headers: this.createHeaders(),
      observe: "response",
    });
  }
  getwityout(url: any) {
    return this._http.get(url, {
      observe: "response",
    });
  }

  post(url: any, data: any) {
    
    return this._http.post(url, data, {
      headers: this.createHeaders(),
      observe: "response",
    });
  }
  async postAsync(url: any, data: any) {
    
    return await this._http.post(url, data, {
      headers: this.createHeaders(),
    });
  }
  postwithout(url: any, data: any) {
    
    return this._http.post(url, data, {
      observe: "response",
    });
  }

  put(url: any, data: any) {
    return this._http.put(url, data, {
      headers: this.createHeaders(),
      observe: "response",
    });
  }
  delete(url: any) {
    return this._http.delete(url, {
      headers: this.createHeaders(),
      observe: "response",
    });
  }
  deleteWithou(url: any) {
    return this._http.delete(url, {
      observe: "response",
    });
  }
}
